"use client"

import { motion } from "framer-motion"
import { allCourses } from "@/pages/courses/data/courses"
import { CourseCard } from "@/components/course-card"
import "../../../../styles/learn-more-button.css"

// Get featured courses: Popular courses from each category
const getFeaturedCourses = () => {
  const courses = []
  
  const quranPopular = allCourses
    .filter(c => c.category === "Quran" && c.badges?.includes("popular"))
    .slice(0, 1)[0]
  if (quranPopular) courses.push(quranPopular)
  
  const arabicPopular = allCourses
    .filter(c => c.category === "Arabic")
    .sort((a, b) => parseInt(b.students) - parseInt(a.students))
    .slice(0, 1)[0]
  if (arabicPopular) courses.push(arabicPopular)
  
  const hifz = allCourses.find(c => c.id === "quran-memorization-hifz")
  if (hifz) courses.push(hifz)
  
  const islamicPopular = allCourses
    .filter(c => c.category === "Islamic Studies")
    .sort((a, b) => parseInt(b.students) - parseInt(a.students))
    .slice(0, 1)[0]
  if (islamicPopular) courses.push(islamicPopular)
  
  return courses
}

export function CoursesOverview() {
  const featuredCourses = getFeaturedCourses()
  
  return (
    <section className="py-16 sm:py-20 lg:py-24">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <motion.div
          className="max-w-2xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center px-3 py-1 text-sm font-medium text-[#245E51] bg-[#A8FF51]/20 rounded-full border border-[#A8FF51]/30">
            Popular Programs
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold tracking-tight leading-tight text-gray-900">
            Our Featured <span className="text-transparent bg-gradient-to-r from-[#245E51] to-[#A8FF51] bg-clip-text">Courses</span>
          </h2>
          <p className="mt-4 text-lg md:text-xl text-gray-600 max-w-2xl mx-auto text-pretty">
            Discover expertly designed courses to elevate your Quranic and Arabic learning journey.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 mt-10 sm:grid-cols-2 lg:mt-16 lg:gap-6 lg:grid-cols-4">
          {featuredCourses.map((course, index) => (
            <CourseCard key={course.id} course={course} index={index} delay={0} />
          ))}
        </div>

        <motion.div
          className="text-center mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          <a href="/courses" className="learn-more">
            View All Courses
          </a>
        </motion.div>
      </div>
    </section>
  )
}
